import { ProgramClass } from '@/models/ProgramClass';
import { ApplicationState } from '@/store';
import { getProgramCoursesRequest, getProgramRequest } from '@/store/program/action';
import { createProgramClassForProgramRequest } from '@/store/programClass/actions';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import _ from 'underscore';
import Classes from '../../../Classes';

const ProgramClasses: React.FC = () => {
    const { program, orgId, programClassCreatedSuccess, newProgramClassId } = useSelector((state: ApplicationState) => ({
        program: state.program.programData,
        orgId: state.identity.data.user.orgId,
        programClassCreatedSuccess: state.programClass.success,
        newProgramClassId: _.last(state.programClass.data)?.id,
    }));

    const [addingNewClass, setAddingNewClass] = useState<boolean>(false);

    const dispatch = useDispatch();
    const history = useHistory();

    const programId: number = parseInt(useParams<{ id: string }>().id);

    const onAddClickHandler = () => {
        setAddingNewClass(true);
        dispatch(
            createProgramClassForProgramRequest({
                programId,
                program,
                name: '',
                orgId,
            } as ProgramClass),
        );
    };

    useEffect(() => {
        if (addingNewClass && programClassCreatedSuccess && newProgramClassId) {
            history.push(`${history.location.pathname}/${newProgramClassId}`);
        }
    }, [addingNewClass, programClassCreatedSuccess, newProgramClassId]);

    useEffect(() => {
        dispatch(getProgramRequest(programId));
        dispatch(getProgramCoursesRequest(programId));
    }, [dispatch, programId]);

    return (
        <Classes
            entity={{
                id: programId,
                name: program.name,
                locale: program.locale,
                rootPath: '/contents/lms/programs',
                type: program.type,
                status: program.status,
                classType: 'PROGRAM',
            }}
            onAddClickHandler={onAddClickHandler}
        />
    );
};

export default ProgramClasses;
